import { render, staticRenderFns } from "./MlbSportsBook.vue?vue&type=template&id=31af3850&scoped=true"
import script from "./MlbSportsBook.vue?vue&type=script&lang=js"
export * from "./MlbSportsBook.vue?vue&type=script&lang=js"
import style0 from "./MlbSportsBook.vue?vue&type=style&index=0&id=31af3850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af3850",
  null
  
)

export default component.exports